import { render, staticRenderFns } from "./VacancySourceChart.vue?vue&type=template&id=2fb61df1&"
import script from "./VacancySourceChart.vue?vue&type=script&lang=js&"
export * from "./VacancySourceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports